module.exports = __webpack_public_path__ + "img/slide2.6afd5584.png";